import { Model } from "./model";

export class SubExtra extends Model {
  // id; selected; name; price
}